import SeoSection from './SeoSection';

export default SeoSection;
